
<template>
  <div>
    <div class="video-arrow" :class=" { 'active' : scrolltop < 20 } ">
      <div class="container text-center">
        <div class="row">
          <div class=""><i class="fas fa-chevron-down"></i></div>
        </div>
      </div>
  </div>
  <div class="video-boxes">
    <div class="container">
      <div class="row">
        <div :class=" { 'col-sm-3': colWidth == 4, 'col-sm-4': colWidth <= 3 } " v-for="(video, index) in video_data.array">
          <div class="video-box" :style=" { 'background-image': 'url(static/img/content/' + video.img +')'  } " @click="clickVideoBox(video.id, video.label)">
              <i class="fas fa-play-circle video-box-playicon"></i>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 text-center">
          <label>{{ video_data.title }}</label>
        </div>

      </div>
    </div>
  </div>

  <transition name="fade" mode="out-in">
  <div class="video-box-container" v-show="playVideo">

        <div class="container container-video">
          <div class="row">
            <div class="col-sm-12 video-box-col">
                    <div class="video-box-inset-container">
        <iframe :src="videoUrl"
             frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen autoplay></iframe>
             
           </div>
         </div>
       </div>
      </div>
      <div class="video-box-close" @click="closeBox()">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>

        <label>{{ videoTitle }}</label>
  </div>
</transition>
</div>
  
</template>

<script>
import {commontools} from '../mixins/Styling'

export default {
  props: ['videos'],
  mixins: [commontools],
  data: function () {
    return {
        video_data: {},
        colWidth: 0,
        videoId: null,
        playVideo: false,
        videoUrl: null,
        videoTitle: null,
        scrolltop: 0
    }
  },
  methods: {
    getColWidth: function () {
      this.colWidth = this.video_data.array.length
      if (this.colWidth > 4) this.colWidth = 4
    },
    clickVideoBox: function (_id, _title) {
      this.videoTitle = _title
      this.videoUrl = 'https://player.vimeo.com/video/' + _id + '?background=0&autoplay=1&muted=0&loop=0&byline=0&title=0'
      this.playVideo = true
    },
    closeBox: function () {
      this.playVideo = false
      this.videoTitle = null
      this.videoUrl = null
    },
    handleNavScroll: function () {
      this.scrolltop = window.scrollY
      console.log(this.scrolltop)
    }
  },
  mounted: function () {
    this.video_data = this.videos
    this.getColWidth()
  },
  created () {
    window.addEventListener('scroll', this.handleNavScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleNavScroll)
  },
  computed: {
    // a computed getter
  },
  components: {
  }
}
</script>

<style>
@import '../../static/css/vars.css';

.video-box-container {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,1);
  top: 0;
  z-index: 99999;
}
.video-boxes {
  margin-top: 15px;
}
.video-boxes label {
    font-size: 16px;
  margin: 20px 0 0;
  width: 100%;
  text-align: center;
}
.video-box {
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  background-size: cover;
  padding-bottom: 100%;
  cursor: pointer;
  margin-bottom: 20px;
}
.video-boxes .col-sm-3:nth-last-child(1) > .video-box,
.video-boxes .col-sm-4:nth-last-child(1) > .video-box {
  margin-bottom: 0;
}
.no-touch-device .video-box:hover {
  opacity: 0.7
}
.touch-device .video-box:active {
  opacity: 0.7
}
.video-box-container .video-box-inset-container {
  width: 100%;
  top: 50%;
  position: relative;
  transform: translateY(-50%);
}
.video-box-col {
  height: 100%;
}
.video-box-playicon {
  position: absolute;
  top:50%;
  left: 50%;
  font-size: 64px;
  color:#fff;
  opacity: 0.85;
  transform: translate3d(-50%, -50%, 0);
  -webkit-transform: translate3d(-50%, -50%, 0);
}
.video-box-inset-container iframe {
  left:0;
    top:0;
    height:295px;
    width:100%;
    position:relative;
}
.video-box-container label {
  position: absolute;
  bottom: 0px;
  padding: 5px 0;
      font-size: 16px;
  margin: 20px 0 0;
  width: 100%;
  text-align: center;
  color: #fff;
  background-color: rgba(202,232,220, 0.5);
}
.video-box-close {
  position: absolute;
  top:10px;
  right:10px;
  width: 40px;
  height: 40px;
  background-color: #000;
  color:#fff;
  cursor: pointer;
  transition: all .3s ease;
  -webkit-transition: all .3s ease;
  font-size: 30px;
  line-height: 40px;
  text-align: center;
}
.video-box-close i {
  line-height: 40px;
}

.no-touch-device .video-box-close:hover {
  background-color: var(--main-color);
}
.video-box-close:active {
  opacity: 0.8;
  -webkit-transform: scale3d(0.9,0.9, 0.9);
  -ms-transform: scale3d(0.9,0.9, 0.9);
  -moz-transform: scale3d(0.9,0.9, 0.9);
  transform: scale3d(0.9,0.9, 0.9);
}
.touch-device .video-box-close:active {
  background-color: var(--main-color);
}
.video-arrow {
  font-size: 24px;
  margin-top: 10px;
  color: #cccccc;
  opacity: 0
}
.video-arrow.active {
  opacity: 1
}


@media (max-width: 575px) {
  .container-video {
    width: 100%!important;
  }
}


@media (min-width: 576px) {
  .video-box-inset-container {
    padding-bottom: 0;
  }
  .video-box-inset-container iframe {
    height:292.5px;
  }
}
@media (min-width: 768px) {
  .video-arrow {
    display: block;
  }
  .video-box {
    margin-bottom: 0;
  }
  .video-boxes {
  margin-top: 15px;
}
  .video-box-inset-container iframe {
    height:405px;
  }
}
@media (min-width: 992px) {
  .video-box-inset-container iframe {
    height:528.75px;
  }
}


</style>
